import "./StatusBadge.css";

type StatusBadgeProps = {
  status: "up" | "down" | "unknown";
  showText?: boolean;
};

const labels: Record<StatusBadgeProps["status"], string> = {
  up: "UP",
  down: "DOWN",
  unknown: "N/A",
};

export function StatusBadge({ status, showText = true }: StatusBadgeProps) {
  return (
    <span class={`status-badge status-badge--${status}`}>
      <span class="status-badge__dot"></span>
      {showText && <span class="status-badge__label">{labels[status]}</span>}
    </span>
  );
}
